import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "connections", "connectVia", "connectViaContainer" ]

  connect() {
    this.toggleConnectVia()
  }

  toggleConnectVia() {
    const isConnectVia = this.connectionsTarget.value === "must_connect_via"
    const isDisabled = this.connectionsTarget.disabled

    if (isConnectVia) {
      this.connectViaContainerTarget.classList.remove("hidden")
      this.connectViaTarget.disabled = isDisabled
    } else {
      this.connectViaContainerTarget.classList.add("hidden")
      this.connectViaTarget.value = ""
      this.connectViaTarget.disabled = true
    }
  }
}
